import Types from './Types'

const Options = {
  consentBlockMessage: 'The video is blocked due to lack of consent to cookies',
  consentButtonLabel: 'Edit consents',
}
const setup = options => {
  for (let key in options) {
    if (!(key in Options)) return
    Options[key] = options[key]
  }
}

export { setup, Options, Types }
